import RevRaise from "@/hotel_integration_modules/bookingEngines/RevRaise/RevRaise";

declare global {
  interface Window {
    gb_hotel_pid: any;
  }
}

// This is where we'll inject widget as well as handle all other messaging
(() => {
  RevRaise.injectIntegration();
})();
